/**
 * Filtering `/installerProximity` rows by asset capability.
 *
 * Rows are per `(Dealer_id, Location_id)` and capability genuinely differs per
 * row — installer 12 is marine at location 13 and not at 422 — so this filters
 * LOCATIONS, not installers. Never collapse it to an installer-level test.
 *
 * `marine_enabled` is a MySQL tinyint and arrives as the JS number `1`, not
 * `true` and not `"1"`. A `=== true` test silently hides every marine shop.
 *
 * ZERO IMPORTS BY DESIGN — unit-tested directly by
 * `scripts/test/specialistDiscovery.test.mjs`. Do not add imports.
 */

/** Can this specialist LOCATION do marine work? Absent flag means no. */
export function isMarineCapableRow(row) {
  const v = row?.marine_enabled;
  return v === 1 || v === '1' || v === true;
}

/**
 * The specialist rows a dealer may choose from.
 *
 * A marine dealership sees marine-capable locations ONLY. Because its wizard
 * has no Road/Water toggle, a marine dealer who reached a car-only specialist
 * would find an empty Work step with no way to recover — so this filter is the
 * only thing preventing a dead end, not a convenience.
 *
 * An automotive dealer is unfiltered: a marine-capable shop still does cars.
 */
export function filterSpecialistsForDealer(rows, isMarine) {
  const list = Array.isArray(rows) ? rows : [];
  return isMarine ? list.filter(isMarineCapableRow) : list;
}
